import { RichText } from './richText';

export default RichText;
